module.exports = __webpack_public_path__ + "static/media/WaitApprove.f58b9271.svg";